export default {
    methods: {
        sortAlphabeticallyAsc (data) {
            let array = Array.from(data).sort((a, b) => {
                if (!a.label) {
                    return 1
                }

                if (!b.label) {
                    return -1
                }

                return a.label.localeCompare(b.label)
            })

            let otherJob
            switch (this.$totemLang) {
            case 'fi':
                otherJob = 'Muu'
                break
            case 'se':
                otherJob = 'Övrigt'
                break
            case 'no':
                otherJob = 'Annet'
                break
            }

            let otherJobObject = array.find(element => element.label === otherJob)
            let filteredArray = array.filter(element => element.label !== otherJob)
            let result = [...filteredArray, otherJobObject ]

            return result
        }
    }
}
